import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/userProfileSagas";
import EditForm from "./smartComponents/EditForm";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import { useLightTheme } from "../../hooks/useLightTheme";
import logoMd from "../../../assets/images/ikizmet-md.png";
import logoDark from "../../../assets/images/ikizmet-dark.png";
import "./userProfile.scss";

const UserProfileModule = () => {
  const dispatch = useDispatch();
  const isLight = useLightTheme();

  const isLoading = useSelector((state) => state.userProfile.isLoading);

  useEffect(() => {
    dispatch(actionCreators.fetchProfile());
  }, [dispatch]);

  if (isLoading) {
    return <LoadingAnimation />;
  }

  return (
    <div className="signin text-center">
      <div className="outer">
        <div className="middle">
          <div className="inner">
            <div className="mbl">
              <img src={isLight ? logoDark : logoMd} alt="iKizmet" />
            </div>
            <EditForm />
            <a
              href="https://login.ikizmet.com/privacy.html"
              target="_blank"
              rel="noreferrer"
              className="privacy-policy no-decoration"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfileModule;
